export default __webpack_public_path__ + "static/media/White0003.8a174118.png";